import React from "react";
import styled from "styled-components";
import { Text } from "@lmn/design-system";
import { Flights } from "@/lib/Types/Flight";
import FlightDetails from "@/components/UI/FlightDetails/FlightDetails";
import IconArrowRight from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconArrowRight.js";
import TextButton from "@/components/UI/TextButton/TextButton";
import media from "@/styles/mediaQueries";

const Container = styled.div(() => ({
  gridArea: "flights",
  display: "flex",
  flexDirection: "column" as const,
}));

const ContentContainer = styled.div(({ theme }) => ({
  border: `1px solid`,
  borderColor: theme.kallisto.color.border.static.borderDisabled,
  padding: theme.kallisto.space.space150,
  borderRadius: theme.kallisto.border.radius.radius100,
  flex: 1,
  display: "flex",
  flexDirection: "column" as const,
}));

const ContentTitles = styled.div(() => ({
  display: "flex",
  flexDirection: "row" as const,
  justifyContent: "space-between",
  alignItems: "baseline",
}));

const AlternativeFlightsTrigger = styled(TextButton)(() => ({
  marginTop: "0",
  ...media.screenSmMin({
    marginTop: "auto",
  }),
}));

const Spacer = styled.div(() => ({
  height: "32px",
}));

interface OfferFlightsProps {
  flights: Flights;
  showDetailsLink: boolean;
  onDetailsClick: () => void;
  onAlternativeFlightsClick: () => void;
  isFetchingAlternativeFlights: boolean;
  hasNoAlternativeFlights: boolean;
  isAlternativeFlightsDisabled: boolean;
  outwardFlightChanged?: boolean;
  returnFlightChanged?: boolean;
}

const OfferFlights: React.FC<OfferFlightsProps> = ({
  flights,
  showDetailsLink,
  onDetailsClick,
  onAlternativeFlightsClick,
  isFetchingAlternativeFlights,
  hasNoAlternativeFlights,
  isAlternativeFlightsDisabled,
  outwardFlightChanged,
  returnFlightChanged,
}) => {
  return (
    <Container>
      <ContentTitles>
        <Text variant="Title6" forceTag="h4" margin={{ bottom: "space100" }}>
          Fluginfos
        </Text>
        {showDetailsLink && (
          <TextButton onClick={onDetailsClick}>Flugdetails</TextButton>
        )}
      </ContentTitles>

      <ContentContainer>
        <FlightDetails
          flights={flights}
          showAirlineIcon
          outwardFlightChanged={outwardFlightChanged}
          returnFlightChanged={returnFlightChanged}
        />

        {showDetailsLink && (
          <>
            <Spacer />
            <AlternativeFlightsTrigger
              variant="action"
              onClick={onAlternativeFlightsClick}
              data-testid="alternative-flights-button"
              disabled={
                isFetchingAlternativeFlights ||
                hasNoAlternativeFlights ||
                isAlternativeFlightsDisabled
              }
            >
              {isFetchingAlternativeFlights ? (
                <span>wird geprüft...</span>
              ) : hasNoAlternativeFlights ? (
                <span>keine alternativen Flüge verfügbar</span>
              ) : (
                <>
                  <span>Flug anpassen</span>
                  <IconArrowRight size={12} />
                </>
              )}
            </AlternativeFlightsTrigger>
          </>
        )}
      </ContentContainer>
    </Container>
  );
};

export default OfferFlights;
